<template>
  <div class="configurator-modal px-0">
    <div class="configurator-modal__overlay" @click="closeModal"></div>
    <div class="container-xl">
      <div class="row mx-auto">
        <div class="col-12 col-lg-8 col-xl-6 mx-auto configurator-modal__card">
          <span>{{ subtitle }}</span>
          <h3>{{ title }}</h3>
          <div class="my-4">
            <span class="d-block mb-1">Wat voor een pakket wil je?</span>
            <div class="row g-2 g-md-3">
              <div class="col-md-6">
                <label
                  class="card-selection card-selection--large card-selection--radio"
                >
                  <span class="image mt-md-n1">
                    <figure class="rimg rimg--contain rimg--100-100">
                      <img
                        :src="packageTypeImageBox"
                        alt="Groot pakket"
                        loading="lazy"
                      />
                    </figure>
                  </span>

                  <!-- Heading -->
                  <span class="method-heading">
                    <span class="fw-base lh-sm">
                      Ik wil een <br /><span class="fw-semi-bold">pakket</span>
                      of <span class="fw-semi-bold">geschenk</span>
                    </span>
                  </span>

                  <!-- Checkbox -->
                  <input
                    type="radio"
                    value="large"
                    v-model="localType"
                    name="localType"
                    class="form-check-input"
                  />
                </label>
              </div>
              <div class="col-md-6">
                <label
                  class="card-selection card-selection--large card-selection--radio"
                >
                  <span class="image mt-md-n1">
                    <figure class="rimg rimg--contain rimg--100-100">
                      <img
                        :src="packageTypeImageMailbox"
                        alt="Brievenbuspakket"
                        loading="lazy"
                      />
                    </figure>
                  </span>

                  <!-- Heading -->
                  <span class="method-heading">
                    <span class="fw-base lh-sm">
                      Ik wil een<br />
                      <span class="fw-semi-bold">brievenbus<wbr />pakket</span>
                    </span>
                  </span>

                  <!-- Checkbox -->
                  <input
                    type="radio"
                    value="small"
                    v-model="localType"
                    name="localType"
                    class="form-check-input"
                  />
                </label>
              </div>
            </div>
          </div>
          <div
            v-if="
              preselectedProduct && !preselectedProduct.isBrievenbusCompatible
            "
            class="alert alert-info p-3 rounded-2 mb-4"
          >
            <p class="mb-0">
              <strong>{{ preselectedProduct.product.name }}</strong> is alleen
              geschikt voor een regulier pakket. Kies je voor een
              brievenbuspakket, dan start je zonder dit product.
            </p>
          </div>
          <div>
            <span class="d-block mb-1"
              >Hoeveel pakketten verwacht je nodig te hebben?</span
            >
            <div class="d-flex gap-3">
              <div class="d-flex align-items-center">
                <QuantityInput
                  :value="localQuantity"
                  :min="10"
                  :max="99999"
                  :step="1"
                  size="lg"
                  :aria-label="'Aantal pakketten'"
                  @update:value="updateQuantity"
                  @quantity-changed="handleQuantityChanged"
                  @invalid="handleQuantityInvalid"
                  @corrected="handleQuantityCorrected"
                />
              </div>

              <!-- Button -->
              <button
                class="btn btn--cta flex-grow-1"
                @click="confirmSelection"
                :disabled="!isValid"
              >
                <span class="d-sm-none">Stel samen</span>
                <span class="d-none d-sm-inline">Start met samenstellen</span>
                <i class="icon icon-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuantityInput from '../components/QuantityInput.vue';

export default {
  name: 'PackageTypeModal',
  components: {
    QuantityInput,
  },
  props: {
    flowType: {
      type: String,
      default: 'compose',
      validator: (value) => ['compose', 'selectPackage'].includes(value),
    },
    packageTypeImageBox: {
      type: String,
      default: '/resources/assets/images/package_type_box.png',
    },
    packageTypeImageMailbox: {
      type: String,
      default: '/resources/assets/images/package_type_mailbox.png',
    },
    preselectedProduct: {
      type: Object,
      default: null,
    },
  },
  emits: ['confirm', 'close-modal'],
  data() {
    return {
      localQuantity: 10,
      localType: 'large',
    };
  },
  computed: {
    isValid() {
      return (
        this.localType &&
        !isNaN(this.localQuantity) &&
        this.localQuantity >= 10 &&
        this.localQuantity <= 99999
      );
    },
    subtitle() {
      return this.flowType === 'compose'
        ? 'Eigen pakket samenstellen'
        : 'Samenstellen op basispakket';
    },
    title() {
      return this.flowType === 'compose'
        ? 'Voor we losgaan: eerst even een aantal vragen!'
        : 'Nog een aantal vragen, daarna breiden we uw basispakket uit';
    },
  },
  mounted() {
    if (isNaN(this.localQuantity)) {
      this.localQuantity = 10;
    }
  },
  methods: {
    updateQuantity(newQuantity) {
      this.localQuantity = newQuantity;
    },

    handleQuantityChanged(event) {
      // Quantity changed event handled
    },

    handleQuantityInvalid(event) {
      // Quantity invalid event handled
    },

    handleQuantityCorrected(event) {
      // Quantity corrected event handled
    },
    confirmSelection() {
      window.globalProductCache = {};
      if (this.isValid && !isNaN(this.localQuantity)) {
        this.$emit('confirm', this.localType, this.localQuantity);
      }
    },
    resetChoice() {
      this.localType = 'large';
      this.localQuantity = 10;
      sessionStorage.removeItem('s7_package_type');
      sessionStorage.removeItem('s7_package_quantity');
    },
    closeModal() {
      this.$emit('close-modal');
    },
  },
};
</script>
